import '~/styles/bundles/sections/header.css';
import '~/styles/bundles/snippets/resp-banner.css';
import '~/styles/bundles/sections/main-product.css';
import '~/styles/bundles/sections/footer.css';

import wc from '~js/wc/base';
import megamenu from '~js/wc/megamenu';
import mobileNavBar from '~js/wc/mobile-nav-bar';

export default {
  wc,
  megamenu,
  mobileNavBar,
};
